/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
import styled from 'styled-components'
import { Theme } from '@nexigendigital/nxui'
import { WEIGHT } from 'helpers/constants'

export const Loader = {
    Container: styled.div`
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    `,
    Message: styled.p`
        ${Theme.Functions.setFont('Inter', WEIGHT.SEMI_BOLD)};
    `
}
